export default __webpack_public_path__ + "images/Comfort-Food.e81eab.jpg";